import { render, staticRenderFns } from "./QuestionDifficultyTrend.vue?vue&type=template&id=2be01e28&scoped=true"
import script from "./QuestionDifficultyTrend.vue?vue&type=script&lang=js"
export * from "./QuestionDifficultyTrend.vue?vue&type=script&lang=js"
import style0 from "./QuestionDifficultyTrend.vue?vue&type=style&index=0&id=2be01e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be01e28",
  null
  
)

export default component.exports